
export default {
  mounted() {
    this.$nextTick(() => {
      // create
      const mm = this.$gsap.matchMedia(this.$refs.container)

      // add a media query. When it matches, the associated function will run
      mm.add('(min-width: 1024px)', () => {
        this.$gsap.set(['.colored-chairs', '.rings'], {
          transformOrigin: 'center',
        })

        const tl = this.$gsap.timeline({
          scrollTrigger: {
            trigger: this.$refs.container,
            // pin: true,
            start: 'center bottom',
            // end: 'center center',
            // markers: true,
            // scrub: true,
          },
        })
        tl.to('.rings', {
          rotate: 360,
          duration: 160,
          replay: -1,
        })
        tl.to(
          '.colored-chairs',
          {
            rotate: -360,
            duration: 160,
            replay: -1,
          },
          '<'
        )
      })
    })
  },
}
